import React from 'react';
import { Box, ButtonBase, Tooltip, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../contexts/LanguageContext';

const languages: Array<{ value: 'ru' | 'en'; label: string }> = [
  { value: 'ru', label: 'RU' },
  { value: 'en', label: 'EN' },
];

export default function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();
  const { t } = useTranslation();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box
      role="group"
      aria-label={t('language.switchLabel')}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '2px',
        padding: '4px',
        borderRadius: '999px',
        border: '1px solid var(--border)',
        background: isDark ? 'rgba(255,255,255,0.04)' : 'rgba(15,23,42,0.03)',
      }}
    >
      {languages.map((lang) => {
        const active = language === lang.value;
        return (
          <Tooltip key={lang.value} title={lang.label} enterDelay={400}>
            <ButtonBase
              onClick={() => setLanguage(lang.value)}
              aria-pressed={active}
              component="button"
              sx={{
                width: 34,
                height: 30,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '999px',
                fontSize: '0.68rem',
                fontWeight: 700,
                letterSpacing: '0.02em',
                color: active ? 'var(--text)' : 'var(--text-subtle)',
                background: active
                  ? isDark
                    ? 'rgba(255,255,255,0.08)'
                    : 'rgba(255,255,255,0.9)'
                  : 'transparent',
                boxShadow: active ? '0 1px 3px rgba(0,0,0,.15)' : 'none',
                transition: 'background .25s ease, color .2s ease, box-shadow .25s ease',
                '&:hover': {
                  color: 'var(--text)',
                  background: active
                    ? isDark ? 'rgba(255,255,255,0.10)' : 'rgba(255,255,255,0.95)'
                    : isDark ? 'rgba(255,255,255,0.05)' : 'rgba(15,23,42,0.04)',
                },
              }}
            >
              {lang.label}
            </ButtonBase>
          </Tooltip>
        );
      })}
    </Box>
  );
}
